// extracted by mini-css-extract-plugin
export default {"dialogTitle":"AddFeatureModal_dialogTitle__y51tq","dialogContentText":"AddFeatureModal_dialogContentText__ZrWQ5"};